<svg
    version="1.1"
    id="lni_lni-frame-expand"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 64 64"
    style="enable-background:new 0 0 64 64;"
    xml:space="preserve"
>
    <g>
        <path
            d="M18.8,1.3h-13c-2.5,0-4.5,2-4.5,4.5v13c0,1,0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8v-13c0-0.6,0.5-1,1-1h13c1,0,1.8-0.8,1.8-1.8
		S19.8,1.3,18.8,1.3z"
        />
        <path
            d="M58.2,1.3h-13c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8h13c0.6,0,1,0.5,1,1v13c0,1,0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8v-13
		C62.8,3.3,60.7,1.3,58.2,1.3z"
        />
        <path
            d="M61,43.4c-1,0-1.8,0.8-1.8,1.8v13c0,0.6-0.5,1-1,1h-13c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8h13c2.5,0,4.5-2,4.5-4.5v-13
		C62.8,44.2,62,43.4,61,43.4z"
        />
        <path
            d="M18.8,59.3h-13c-0.6,0-1-0.5-1-1v-13c0-1-0.8-1.8-1.8-1.8s-1.8,0.8-1.8,1.8v13c0,2.5,2,4.5,4.5,4.5h13c1,0,1.8-0.8,1.8-1.8
		S19.8,59.3,18.8,59.3z"
        />
    </g>
</svg>

<style>
    svg {
        fill: var(--grey);
		stroke: var(--grey);
    }

    svg:hover {
        fill: var(--lines);
		stroke: var(--lines);
    }
</style>
